module.exports = __webpack_public_path__ + "img/mobile_map_regional.79fe6893.svg";